import { render, staticRenderFns } from "./DTextareaEditor.vue?vue&type=template&id=1dde1b70&"
import script from "./DTextareaEditor.vue?vue&type=script&lang=js&"
export * from "./DTextareaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports